import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import AppNavbar from "../components/home/Navbar";
import Footer from "../components/footer/Footer";
import Seo from "../components/seo/Seo";
import { faqCategories } from "../components/home/faqContent";
import "../components/home/FAQ.css";
import "./styles/faq-page.css";
import { PAGES } from "../content/pages";

// Every answer is in the page (closed questions included), so search
// engines can read them; the structured data lets them show the answers
const structuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqCategories.flatMap((category) =>
    category.questions.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: { "@type": "Answer", text: answer },
    })),
  ),
};

function FaqPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Seo {...PAGES.faq} />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <AppNavbar />

      <main className="faq faq-page">
        <Container>
          <header className="faq-header">
            <p className="eyebrow mb-2">Questions fréquentes</p>
            <h1 className="faq-title">Comment pouvons-nous vous aider ?</h1>
          </header>

          <nav className="faq-tabs" aria-label="Thèmes">
            {faqCategories.map((category) => (
              <a key={category.id} href={`#${category.id}`} className="faq-tab">
                {category.label}
              </a>
            ))}
          </nav>

          {faqCategories.map((category) => (
            <section
              key={category.id}
              id={category.id}
              className="faq-page-section"
              aria-labelledby={`${category.id}-title`}
            >
              <h2 id={`${category.id}-title`} className="faq-page-heading">
                {category.label}
              </h2>
              <div className="faq-list">
                {category.questions.map(({ question, answer }) => (
                  <details key={question} className="faq-item">
                    <summary className="faq-question">
                      <span>{question}</span>
                      <span className="faq-icon" aria-hidden="true" />
                    </summary>
                    <p className="faq-answer">{answer}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}

          <p className="faq-page-contact">
            Vous ne trouvez pas votre réponse ? Écrivez-nous à{" "}
            <a href="mailto:support@platform98.com">support@platform98.com</a>{" "}
            ou sur{" "}
            <a
              href="https://wa.me/237677200200"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>
            .
          </p>
        </Container>
      </main>

      <Footer />
    </>
  );
}

export default FaqPage;
